import React, { CSSProperties } from 'react';
import { Box } from '../primitives';

type Props = {
  callback: () => void;
  style?: CSSProperties;
};

const RetryButton = ({ callback, style }: Props) => (
  <Box mr="small">
    <div style={style}>
      <button onClick={callback}>!</button>
    </div>
  </Box>
);

export default RetryButton;
